export default __webpack_public_path__ + "static/media/logo.5d4edd01.png";